if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
          element.closest('.product-media-modal__media')?.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        // Fix (2026-09-09, Joerg-Feedback "leere Lightbox auf Mobil"): Auf Mobil (< 750px)
        // blendet section-main-product.css direkte Kind-Elemente von
        // ".product-media-modal__content" aus, wenn sie kein ".active" tragen - das sind
        // die ".product-media-modal__media"-Wrapper-Divs, NICHT das <img>/<deferred-media>,
        // dem oben "active" zugewiesen wird. Auf Desktop (>=750px) werden ohnehin alle
        // Elemente gezeigt, weshalb der fehlende Wrapper-Status dort nie auffiel.
        activeMedia.closest('.product-media-modal__media')?.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
